import { useEffect, useState } from "react";
import { useFavoriteToggleMutation, useGetFavoriteArticlesQuery } from "@/App/services/resourcesApiSlice";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import empty from "../../Images/noWorksheet.png";
import Loader from "@/Components/loader";
import * as Icon from 'react-feather'

const variants = {
  initial: {
    opacity: 0,
    y: 100,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      ease: "easeInOut",
      duration: 0.5,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      ease: "easeOut",
      duration: 0.5,
    },
  },
};

function You() {

  const { data:articles, isLoading } = useGetFavoriteArticlesQuery();
  const [ favoriteToggle, { isError, error } ] = useFavoriteToggleMutation();

  const toggleFavoriteArticle = async(event, courseId) => {
    event.stopPropagation();
    const course = {
      wellness_course_id : courseId
    }
    try {
      const res = await favoriteToggle({ ...course }).unwrap();
      toast.success(res?.message)
    } catch(err) {
      toast.error(err?.data?.message)
    }
  };

  return (
    <motion.div
      key="hello"
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="w-full bg-white border p-4 tablet:p-5 py-5 rounded-[16px] border-[#E2E4E9]">
        <div className="w-full  flex-col my-auto min-h-[100px] laptop:min-h-[292px]  flex justify-center items-center">
          {/* <h3 className="font-semibold text-center text-xl">No article</h3> */}

          {
            isLoading ?
            <Loader />
            :
            !articles?.data?.length ?
            <div className='flex items-center justify-center m-auto w-full h-full p-6 overflow-y-auto'>
              <div className="w-full  flex-col my-auto flex justify-center items-center gap-2">
                  <img src={empty} className="w-[108px]" alt="empty" />
                  <p className="mt-3 text-sm text-[#868C98] text-center w-1/3">
                      There are no articles yet. <br />
                  </p>
              </div>
            </div>
            :
            <div className="w-full grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
              {
                articles?.data?.map((article, index) => (
                  <ArticleCard
                    id={article.id}
                    key={index}
                    text={article.description}
                    title={article.title}
                    img={article?.cover?.url}
                    slug={article?.slug}
                    onFavorite={toggleFavoriteArticle}
                    favorite={article.favourite}
                    isError={isError}
                    error={error}
                  />
                )) 
              }
            </div>
          }
        </div>
      </div>
    </motion.div>
  );
}

export default You;


const ArticleCard = ({ id, img, title, text, slug, favorite, onFavorite, isError, error }) => {

  const navigate = useNavigate();

  const onToggleFavorite = (event) => {
    onFavorite(event, id);
  };

  return (
    <div onClick={() => navigate(`article/${slug}`)} className="flex flex-col items-start rounded-xl border overflow-hidden cursor-pointer">
      <section className="w-full relative">
        <div onClick={(e) => onToggleFavorite(e)} className="flex items-center gap-1 absolute top-0 right-0 text-sm bg-black bg-opacity-30 backdrop-blur-sm rounded-full p-1 m-2 cursor-pointer">
          {/* <span className="text-white">Add to favorites</span> */}
          <Icon.Heart fill={`${ favorite ? "#ff0000" : "none" }`} strokeWidth={1} color="#FFFFFF" size={18} />
        </div>
        <img 
          src={img ?? "https://active-asics.de/wp-content/plugins/breedr//assets/no-image-available.png"}
          className="w-full h-full"
          style={{
            backgroundSize: "100% 100%",
            objectFit: "cover",
            width: "100%",
            height: "200px",
            borderRadius: "3px",
            // objectPosition: "top",
          }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src =
              "https://active-asics.de/wp-content/plugins/breedr//assets/no-image-available.png";
          }}
        />
      </section>
      <main className="flex flex-col items-start gap-3 p-4">
        <p className="text-base font-semibold text-[#0A0D14]">{title}</p>
        <span className="text-[#525866] text-sm line-clamp-3">{text}</span>
      </main>
    </div>
  )
}